import React from 'react';
import { Link } from 'react-router-dom';

const Pagination = ({ currentPage, totalPages, basePath }) => {
  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;
    const startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  };
  
  if (totalPages <= 1) return null;
  
  return (
    <div style={styles.paginationContainer}>
      <div style={styles.pagination}>
        {/* Previous Button */}
        {currentPage > 1 && (
          <Link 
            to={currentPage === 2 ? basePath : `${basePath}/page/${currentPage - 1}`}
            style={styles.pageLink}
          >
            <button style={styles.pageButton}>
              ‹ Predchádzajúca
            </button>
          </Link>
        )}
        
        {/* First page if not visible */}
        {getPageNumbers()[0] > 1 && (
          <>
            <Link to={basePath} style={styles.pageLink}>
              <button style={styles.pageButton}>1</button>
            </Link>
            {getPageNumbers()[0] > 2 && <span style={styles.ellipsis}>...</span>}
          </>
        )}
        
        {/* Page numbers */}
        {getPageNumbers().map(pageNum => (
          <Link 
            key={pageNum}
            to={pageNum === 1 ? basePath : `${basePath}/page/${pageNum}`}
            style={styles.pageLink}
          >
            <button 
              style={{
                ...styles.pageButton,
                ...(pageNum === currentPage ? styles.activePage : {})
              }}
            >
              {pageNum}
            </button>
          </Link>
        ))}
        
        {/* Last page if not visible */}
        {getPageNumbers()[getPageNumbers().length - 1] < totalPages && (
          <>
            {getPageNumbers()[getPageNumbers().length - 1] < totalPages - 1 && (
              <span style={styles.ellipsis}>...</span>
            )}
            <Link to={`${basePath}/page/${totalPages}`} style={styles.pageLink}>
              <button style={styles.pageButton}>{totalPages}</button>
            </Link>
          </>
        )}
        
        {/* Next Button */}
        {currentPage < totalPages && (
          <Link 
            to={`${basePath}/page/${currentPage + 1}`}
            style={styles.pageLink}
          >
            <button style={styles.pageButton}>
              Nasledujúca ›
            </button>
          </Link>
        )}
      </div>
    </div>
  );
};

const styles = {
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2rem 0',
    marginTop: '2rem',
  },
  pagination: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  pageLink: {
    textDecoration: 'none',
  },
  pageButton: {
    padding: '0.75rem 1rem',
    border: '1px solid #ddd',
    backgroundColor: '#fff',
    color: '#333',
    cursor: 'pointer',
    borderRadius: '4px',
    fontSize: '1rem',
    transition: 'all 0.2s ease',
    minWidth: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  activePage: {
    backgroundColor: '#2c69a0',
    color: '#fff',
    borderColor: '#2c69a0',
  },
  ellipsis: {
    padding: '0.75rem 0.5rem',
    color: '#666',
    fontSize: '1rem',
  },
};

// Add hover styles with CSS
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  .pagination-button:hover:not(.active) {
    background-color: #f5f5f5 !important;
    border-color: #bbb !important;
  }
`;
document.head.appendChild(styleSheet);

export default Pagination; 